import BaseButton from 'components/atoms/baseButton';
import i18next from 'i18next';
import { useState } from 'react';

import BingoCardModal from './bingoCardModal';

interface IBingoActionsProps {
  bingoNumbers: number[];
  cardNumber: number;
  openedNumbers: number[];
}

export default function BingoActions(props: IBingoActionsProps) {
  const [showBingoCardModal, setShowBingoCardModal] = useState<boolean>(false);
  const toggleShowBingoCardModal = () => setShowBingoCardModal((p) => !p);

  const { bingoNumbers, cardNumber, openedNumbers } = props;
  return (
    <>
      <BaseButton
        onClick={toggleShowBingoCardModal}
        label={i18next.t('labels.showCard')}
      />
      <BingoCardModal
        bingoNumbers={bingoNumbers}
        cardNumber={cardNumber}
        openedNumbers={openedNumbers}
        showBingoCardModal={showBingoCardModal}
        toggleShowBingoCardModal={toggleShowBingoCardModal}
      />
    </>
  );
}
